var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"burger lg:hidden",attrs:{"id":"burger"},on:{"click":_vm.open}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"burger-button",attrs:{"type":"button"}},[_c('span',{staticClass:"burger-bar burger-bar__1"}),_c('span',{staticClass:"burger-bar burger-bar__2"}),_c('span',{staticClass:"burger-bar burger-bar__3"})])
}]

export { render, staticRenderFns }